module.exports = __webpack_public_path__ + "static/img/MaLie_banner_autumn.452ab366.jpg";